
import { defineComponent, SetupContext, computed } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsRadioButtonItem",
  props: {
    /** 添字 */
    index: {
      type: Number,
      required: true
    },
    /** 表示する文字列 */
    text: {
      type: String,
      required: true
    },
    /** 選択中 */
    selected: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const selectItem = () => {
      NativeClient.sendDebugLog("FridgeDetailsRadioButtonItem selectItem index = " + props.index + ", selected = " + props.selected);
      if (props.selected) {
        return;
      }
      context.emit("select-index", props.index)
    }
    const buttonImage = computed(() => {
      if (props.selected) {
        return require('@/assets/images/icn-radio-selected.png')
      }
      return require('@/assets/images/icn-radio-unselected.png')
    });

    return {
      selectItem,
      buttonImage
    };
  }
});
